import { useState } from "react";
import { Bell } from "lucide-react";
import NotificationList from "./NotificationList";
import { markAllNotificationsAsRead } from "../../notifications/notificationService";
import { useUnreadCount } from "../../notifications/unreadCount";

const NotificationBell = ({ userId }) => {
  const { notifications, unreadCount } = useUnreadCount(userId);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDropdownToggle = () => {
    const newState = !isDropdownOpen;
    setIsDropdownOpen(newState);
    if (newState) {
      markAllNotificationsAsRead(userId);
    }
  };

  return (
    <div className="relative">
      <button
        className="relative text-white rounded-full p-2"
        onClick={handleDropdownToggle}
      >
        <Bell className="w-6 h-6" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
            {unreadCount}
          </span>
        )}
      </button>
      <div className="absolute mt-2 z-50 notification-dropdown">
        {isDropdownOpen && (
          <div className="absolute mt-2 z-50 notification-dropdown">
            <NotificationList notifications={notifications} />
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationBell;
